// notification.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of } from "rxjs";

@Injectable({ providedIn: "root" })
export class NotificationService {
  constructor(private http: HttpClient) {}

  notifyInstructorConflict(args: {
    instructorId: string;
    instructorEmail?: string; // si tu l’as dans le modèle
    dateISO: string; // jour
    startISO: string;
    endISO: string;
    aircraftCode?: string;
    createdByName: string;
  }) {
    console.log("Conflit instructeur");
    return of([]);
    // 👉 adapte l’URL / payload à ton API
    // return this.http.post("/api/notifications/instructor-conflict", args);
  }
}
